
const ADNOCServices = () => {
  const onshoreServices = [
    {
      field: "Shah Gas Field",
      services: ["Sour gas treatment chemicals", "H2S scavenging solutions", "Corrosion inhibitor programs", "Scale prevention systems"]
    },
    {
      field: "Bab Field",
      services: ["Enhanced oil recovery chemicals", "Water injection treatments", "Production optimization", "Asset integrity solutions"]
    },
    {
      field: "Bu Hasa Field",
      services: ["Drilling fluid systems", "Completion chemicals", "Production enhancement", "Pipeline protection"]
    },
    {
      field: "Asab Field",
      services: ["Heavy oil production chemicals", "Thermal recovery additives", "Viscosity reducers", "Flow assurance solutions"]
    }
  ];

  const offshoreServices = [
    {
      platform: "Umm Shaif Platform",
      services: ["Seawater injection chemicals", "Corrosion inhibition", "Scale control systems", "Biocide treatments"]
    },
    {
      platform: "Zakum Field",
      services: ["Artificial lift chemicals", "Gas lift optimization", "Water treatment solutions", "Environmental compliance"]
    },
    {
      platform: "Fateh Field",
      services: ["Mature field chemicals", "Enhanced recovery solutions", "Equipment protection", "Operational efficiency"]
    },
    {
      platform: "Margham Field",
      services: ["Drilling optimization", "Completion fluids", "Production chemicals", "Subsea treatments"]
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            ADNOC Onshore & Offshore Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized chemical supply projects and services for ADNOC operations across 
            UAE's major onshore and offshore oil and gas fields.
          </p>
        </div>

        {/* ADNOC Onshore */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-landscape-line text-teal-600 mr-3"></i>
              ADNOC Onshore Operations
            </h3>
            <p className="text-lg text-gray-600">
              Comprehensive chemical solutions for major onshore fields and facilities
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {onshoreServices.map((field, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-teal-600 text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">{field.field}</h4>
                </div>
                <div className="space-y-2">
                  {field.services.map((service, serviceIndex) => (
                    <div key={serviceIndex} className="flex items-start space-x-3">
                      <div className="w-5 h-5 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                      <p className="text-gray-700">{service}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ADNOC Offshore */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              <i className="ri-ship-line text-blue-600 mr-3"></i>
              ADNOC Offshore Operations
            </h3>
            <p className="text-lg text-gray-600">
              Specialized chemical solutions for offshore platforms and subsea operations
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {offshoreServices.map((platform, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-anchor-line text-blue-600 text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">{platform.platform}</h4>
                </div>
                <div className="space-y-2">
                  {platform.services.map((service, serviceIndex) => (
                    <div key={serviceIndex} className="flex items-start space-x-3">
                      <div className="w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                      <p className="text-gray-700">{service}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Partnership Highlights */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Strategic Partnership with ADNOC
            </h3>
            <p className="text-lg text-gray-600">
              Golden Black's proven track record and expertise in UAE operations
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-teal-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Certified Supplier</h4>
              <p className="text-gray-600">ADNOC approved chemical supplier with proven quality standards</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-blue-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">24/7 Support</h4>
              <p className="text-gray-600">Round-the-clock technical support and emergency response services</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-green-600 text-3xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Local Presence</h4>
              <p className="text-gray-600">UAE-based operations ensuring rapid response and local expertise</p>
            </div>
          </div>
          
          <div className="mt-8 p-6 bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg">
            <div className="text-center">
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Contact Our ADNOC Specialists</h4>
              <p className="text-gray-600 mb-6">
                Get in touch with our dedicated ADNOC operations team for specialized chemical solutions
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-phone-line text-teal-600 text-lg"></i>
                  <span className="text-gray-700 font-semibold">+971 56 276 1272</span>
                </div>
                <div className="flex items-center justify-center space-x-2">
                  <i className="ri-mail-line text-teal-600 text-lg"></i>
                  <span className="text-gray-700 font-semibold">info@chemsolutionservice.live</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ADNOCServices;
